// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles pour le contenu Markdown */
.markdown-content {
  color: #fff;
}

.markdown-content h1,
.markdown-content h2,
.markdown-content h3,
.markdown-content h4,
.markdown-content h5,
.markdown-content h6 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: 600;
  line-height: 1.25;
  color: #7C5DFA;
}

.markdown-content h1 { font-size: 1.5em; }
.markdown-content h2 { font-size: 1.3em; }
.markdown-content h3 { font-size: 1.15em; }

.markdown-content p {
  margin-top: 0;
  margin-bottom: 12px;
}

.markdown-content code {
  padding: 2px 6px;
  background: rgba(124, 93, 250, 0.15);
  border-radius: 4px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', monospace;
  font-size: 0.9em;
  color: #E06C75;
}

.markdown-content pre {
  padding: 12px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow-x: auto;
  margin: 12px 0;
  border: 1px solid rgba(124, 93, 250, 0.2);
}

.markdown-content pre code {
  background: none;
  padding: 0;
  color: #ABB2BF;
  font-size: 0.85em;
}

.markdown-content ul,
.markdown-content ol {
  margin-top: 0;
  margin-bottom: 12px;
  padding-left: 24px;
}

.markdown-content li {
  margin-bottom: 4px;
}

.markdown-content a {
  color: #7C5DFA;
  text-decoration: none;
}

.markdown-content a:hover {
  text-decoration: underline;
}

.markdown-content blockquote {
  margin: 12px 0;
  padding: 8px 16px;
  border-left: 4px solid #7C5DFA;
  background: rgba(124, 93, 250, 0.1);
  color: rgba(255, 255, 255, 0.8);
}

.markdown-content table {
  border-collapse: collapse;
  margin: 12px 0;
  width: 100%;
}

.markdown-content table th,
.markdown-content table td {
  border: 1px solid rgba(124, 93, 250, 0.3);
  padding: 8px 12px;
  text-align: left;
}

.markdown-content table th {
  background: rgba(124, 93, 250, 0.2);
  font-weight: 600;
}

.markdown-content table tr:nth-child(even) {
  background: rgba(255, 255, 255, 0.02);
}

.markdown-content hr {
  border: none;
  border-top: 1px solid rgba(124, 93, 250, 0.2);
  margin: 16px 0;
}

.markdown-content strong {
  font-weight: 600;
  color: #fff;
}

.markdown-content em {
  font-style: italic;
  color: rgba(255, 255, 255, 0.9);
}

/* Styles généraux */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background: #12151C;
  color: #fff;
  overflow: hidden;
}

#root {
  height: 100%;
}

/* Animations pour les indicateurs WebSocket */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/taskpane.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,WAAW;AACb;;AAEA;;;;;;EAME,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uBAAuB,gBAAgB,EAAE;AACzC,uBAAuB,gBAAgB,EAAE;AACzC,uBAAuB,iBAAiB,EAAE;;AAE1C;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,oEAAoE;EACpE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,8EAA8E;EAC9E,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB","sourcesContent":["/* Styles pour le contenu Markdown */\n.markdown-content {\n  color: #fff;\n}\n\n.markdown-content h1,\n.markdown-content h2,\n.markdown-content h3,\n.markdown-content h4,\n.markdown-content h5,\n.markdown-content h6 {\n  margin-top: 16px;\n  margin-bottom: 8px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: #7C5DFA;\n}\n\n.markdown-content h1 { font-size: 1.5em; }\n.markdown-content h2 { font-size: 1.3em; }\n.markdown-content h3 { font-size: 1.15em; }\n\n.markdown-content p {\n  margin-top: 0;\n  margin-bottom: 12px;\n}\n\n.markdown-content code {\n  padding: 2px 6px;\n  background: rgba(124, 93, 250, 0.15);\n  border-radius: 4px;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', monospace;\n  font-size: 0.9em;\n  color: #E06C75;\n}\n\n.markdown-content pre {\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  overflow-x: auto;\n  margin: 12px 0;\n  border: 1px solid rgba(124, 93, 250, 0.2);\n}\n\n.markdown-content pre code {\n  background: none;\n  padding: 0;\n  color: #ABB2BF;\n  font-size: 0.85em;\n}\n\n.markdown-content ul,\n.markdown-content ol {\n  margin-top: 0;\n  margin-bottom: 12px;\n  padding-left: 24px;\n}\n\n.markdown-content li {\n  margin-bottom: 4px;\n}\n\n.markdown-content a {\n  color: #7C5DFA;\n  text-decoration: none;\n}\n\n.markdown-content a:hover {\n  text-decoration: underline;\n}\n\n.markdown-content blockquote {\n  margin: 12px 0;\n  padding: 8px 16px;\n  border-left: 4px solid #7C5DFA;\n  background: rgba(124, 93, 250, 0.1);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.markdown-content table {\n  border-collapse: collapse;\n  margin: 12px 0;\n  width: 100%;\n}\n\n.markdown-content table th,\n.markdown-content table td {\n  border: 1px solid rgba(124, 93, 250, 0.3);\n  padding: 8px 12px;\n  text-align: left;\n}\n\n.markdown-content table th {\n  background: rgba(124, 93, 250, 0.2);\n  font-weight: 600;\n}\n\n.markdown-content table tr:nth-child(even) {\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.markdown-content hr {\n  border: none;\n  border-top: 1px solid rgba(124, 93, 250, 0.2);\n  margin: 16px 0;\n}\n\n.markdown-content strong {\n  font-weight: 600;\n  color: #fff;\n}\n\n.markdown-content em {\n  font-style: italic;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Styles généraux */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml, body {\n  height: 100%;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  background: #12151C;\n  color: #fff;\n  overflow: hidden;\n}\n\n#root {\n  height: 100%;\n}\n\n/* Animations pour les indicateurs WebSocket */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
